module.exports = __webpack_public_path__ + "static/ui-configurations@2x-bc29f03467856df6377849b72645ac12.png";